<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="row">

      <div class="col-12 col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Zone Preference</h4>
            </div>
          </div>
          <div class="card-body card-map-body">
            <span v-if="deadhead_driver">* Drivers that receive unloaded miles payments are not allowed to edit their Zone Preference. Please contact support if assistance is required.</span>
            <span v-if="showDraw && !deadhead_driver">* Zoom in to the zone you would like to select.</span>
            <br>
            <span v-if="showDraw && !deadhead_driver">* Press the "Draw" button to define the area(s) for which you would like to receive trip requests. You will see available trips that have pick-up or drop-off points within the areas you define.</span>
            <br>
            <input v-if="showDraw && !deadhead_driver" @click="draw()" type="submit" name="commit" value="Draw"
                  class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="Draw" style="margin-bottom: 15px">
            <!--<button v-if="showDraw" id="button-load" v-on:click="loadPolygons">Load</button>-->
            <input v-if="showCancel" @click="cancelDraw()" type="submit" name="commit" value="Cancel"
                  class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="Cancel" style="margin-bottom: 15px">
            <input v-if="showSave" @click="saveDraw()" type="submit" name="commit" value="Save"
                  class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="Save" style="margin-bottom: 15px">
            <div class="d-flex">
              <div id="map" style="width: 100%;height: 500px;margin: auto;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Zone Preference',
    },
    name: 'ZonePreference',
    data () {
      return {
        title: 'Zone Preference',
        data: {},
        id_driver: null,
        driver: null,
        balance: 0,
        isLoading: false,
        loadings: [],
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        with_deactivated: false,
        types: [],
        type_chose: null,
        prev_sort: null,
        map: null,
        showCancel: false,
        showSave: false,
        showDraw: true,
        deadhead_driver: false,
        shapes: [],
        lines: [],
        oldDrawing: null,
      }
    },
    components: {
      Loading
    },
    methods: {
      sort(field) {
        console.log(field)
        let obj = this.$refs[field]
        if (this.prev_sort) {
          this.prev_sort.style.visibility = 'hidden'
        }

        let value = obj.getAttribute('value')
        console.log(obj.getAttribute('name'))
        obj.setAttribute('value', -value)
        console.log(obj.getAttribute('value'))

        obj.style.visibility = 'visible'
        obj.style.transform = "rotate("  + (value>0?0:1) * 180 +  "deg)"

        this.prev_sort = obj

        this.search()
      },
      changeType(event) {
        console.log(event.target.value)
        this.type_chose = event.target.value

        this.search()
      },
      download: function() {
        this.isLoading = true
        this.$http({
          url: process.env.API_BASE_URL + 'download_driver_transaction/?id_user=' + this.id_driver,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'driver-dashboard-for-' + this.driver.name_first + '-' + this.driver.name_last + '.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.isLoading = false
        });
      },
      getTypes: function () {
        this.$http
          .get(process.env.API_BASE_URL + 'type-transactions/')
          .then(response => {
            console.log(response.data)
            this.types = response.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {

          })
      },
      getBalance: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_driver + '/?type=balance')
          .then(response => {
            console.log(response.data)
            this.balance = response.data.balance

            this.search()
            this.getTypes()
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {

          })
      },
      getUserInfo: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_driver + '/')
          .then(response => {
            console.log(response.data)
            this.driver = response.data
            if (this.driver.id_driver.id_type_driver_account.id_type_driver_account == 5) {
              console.log('deadhead')
              this.deadhead_driver = true;
            } else {
              console.log('not deadhead')
            }
            this.getBalance()
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {
            this.initMap()
          })
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'transactions/?to_id_user=' + this.id_driver
            + '&page=' + (page ? page : this.currentPage)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + (this.type_chose ? '&id_type_transaction=' + this.type_chose : ''))
          .then(response => {
            console.log(response.data)
            for (let index in response.data.results) {
              response.data.results[index]['show_details'] = false
            }
            this.data = response.data.results

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      showLoading() {
        this.isLoading = true
        this.loadings.push(1)
      },
      hideLoading() {
        if (this.loadings.length > 0) {
          this.loadings.pop()
        }
        if (this.loadings.length == 0) {
          this.isLoading = false
        }
      },
      saveZone() {
        this.showLoading()
        this.$http
          .post(process.env.API_BASE_URL_CS + 'zones/', {
            id_driver: this.id_driver,
            polygon: this.oldDrawing
          })
          .then(response => {
            console.log("saveZone success")
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.hideLoading()
          })
      },
      getZone() {
        this.showLoading()
        this.$http
          .get(process.env.API_BASE_URL_CS + 'zones/?id_driver=' + this.id_driver)
          .then(response => {
            console.log("zone")
            console.log(response.data)
            this.oldDrawing = response.data[0].polygon.replace("SRID=4326;", '')
            this.loadPolygons(this.oldDrawing)
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.hideLoading()
          })
      },
      loadPolygons: function(source) {

        var wkt=source; //this is your WKT string

        // console.log(wkt)

        //using regex, we will get the indivudal Rings
        var regex = /\(([^()]+)\)/g;
        var Rings = [];
        var results;
        while( results = regex.exec(wkt) ) {
          Rings.push( results[1] );
        }
        // console.log(Rings)

        var shapes = []

        var polyLen=Rings.length;
        // console.log(polyLen)

        //now we need to draw the polygon for each of inner rings, but reversed
        for(var i=0;i<polyLen;i++){
          var ptsArray=[];
          var data = Rings[i]
          // console.log(data)

          //first spilt the string into individual points
          var pointsData=data.split(",");
          // console.log(pointsData)

          //iterate over each points data and create a latlong
          //& add it to the cords array
          var len=pointsData.length;
          for (var j=0;j<len;j++)
          {
            var xy=pointsData[j].trim().split(" ");
            // console.log(xy[1])
            // console.log(xy[0])
            var lat = parseFloat(xy[1]).toFixed(6)
            var lng = parseFloat(xy[0]).toFixed(6)
            // console.log(lat)
            // console.log(lng)

            var pt=new google.maps.LatLng(lat,lng);
            ptsArray.push(pt);
          }

          shapes.push(ptsArray);
        }

        for (var i = 0; i < shapes.length; i++) {
          var ptsArray = shapes[i];
          window.poly = new google.maps.Polygon({
            paths: ptsArray,
            strokeColor: '#1E90FF',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#1E90FF',
            fillOpacity: 0.35
          });

          this.shapes.push(window.poly)

          poly.setMap(this.map);
        }
      },
      saveDraw: function() {
        this.showDraw = true;
        this.showCancel = false;
        this.showSave = false;

        var wkt = "";
        wkt += "MULTIPOLYGON(";

        var polygons = []
        for (var i = 0; i < this.shapes.length; i++) {
          var coords = this.lines[i].getPath().getArray().map(function(n) { return [n.lng().toFixed(6) + ' ' + n.lat().toFixed(6)]; });
          coords.push(coords[0]);

          var polygon = "((";
          polygon += coords.join(",");
          polygon += "))";

          if (polygon != "(())") {
            polygons.push(polygon)
          }
        }

        polygons = polygons.join(",")
        wkt += polygons

        wkt += ")";
        console.log(wkt)

        this.oldDrawing = wkt
        this.saveZone()

        var map = this.map;
        map.setOptions({
          draggable: true,
          scrollwheel: true,
          zoomControl: true,
          disableDoubleClickZoom: true,
          disableDefaultUI: false,
          streetViewControl: false,
        });

        // this will cause zoom buttons not to work
        google.maps.event.clearInstanceListeners(map);
      },
      cancelDraw: function() {
        this.showDraw = true;
        this.showCancel = false;
        this.showSave = false;

        var fixed = document.getElementById('map');
        fixed.removeEventListener('touchmove', this.preventScroll, false);

        for (var i = 0; i < this.shapes.length; i++) {
          this.shapes[i].setMap(null);
        }

        var map = this.map;
        map.setOptions({
          draggable: true,
          scrollwheel: true,
          zoomControl: true,
          disableDoubleClickZoom: true,
          disableDefaultUI: false,
          fullscreenControl: true,
          mapTypeControl: false,
          streetViewControl: false,
        });

        // this will cause zoom buttons not to work
        google.maps.event.clearInstanceListeners(map);

        this.loadPolygons(this.oldDrawing)
      },
      preventScroll: function(e) {
        e.preventDefault();
      },
      draw: function() {
        this.showDraw = false;
        this.showCancel = true;
        this.showSave = true;

        for (var i = 0; i < this.shapes.length; i++) {
          this.shapes[i].setMap(null);
        }

        this.lines = []
        this.shapes = []

        var fixed = document.getElementById('map');
        fixed.addEventListener('touchmove', this.preventScroll, false);

        var map = this.map;
        map.setOptions({
          draggable: false,
          scrollwheel: false,
          zoomControl: false,
          disableDoubleClickZoom: false,
          disableDefaultUI: true,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        });

        google.maps.event.addListener(map,'mousedown',() => {
          //the polygon
          window.poly = new google.maps.Polyline({
            map: map,
            clickable: false,
            strokeColor: '#1E90FF',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#1E90FF',
            fillOpacity: 0.35
          })

          //move-listener
          var move = google.maps.event.addListener(map, 'mousemove', function (e) {
            window.poly.getPath().push(e.latLng)
          })

          //mouseup-listener
          google.maps.event.addListenerOnce(map, 'mouseup', () => {
            google.maps.event.removeListener(move)
            var path = poly.getPath()

            if (!google.maps.geometry) {
              return;
            }

            var line = new google.maps.Polyline({path: path});
            var encoded = google.maps.geometry.encoding.encodePath(line.getPath());
            var tol = 0.0001;
            while (encoded.length > 100) {
              console.log('simplify')
              path = line.simplify(tol);
              line = new google.maps.Polyline({path: path});
              encoded = google.maps.geometry.encoding.encodePath(path);
              tol += .001;
            }

            window.poly.setMap(null)
            window.poly = new google.maps.Polygon({
              map: map,
              path: path,
              strokeColor: '#1E90FF',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#1E90FF',
              fillOpacity: 0.35
            })

            path = line.getPath()

            this.lines.push(line)
            this.shapes.push(window.poly)

            var coords = path.getArray().map(function(n) { return [n.lng().toFixed(6) + ' ' + n.lat().toFixed(6)]; });
            coords.push(coords[0]);

            var wkt = "";
            wkt += "MULTIPOLYGON(";
            wkt += "((";
            wkt += coords.join(",");
            wkt += "))";
            wkt += ")";

            console.log(wkt)

            // google.maps.event.clearListeners(map.getDiv(), 'mousedown')

            // enable()
          })
        });
      },
      initMap: function () {
        google.maps.Polyline.prototype.simplify = function(tolerance) {

          var points = this.getPath().getArray(); // An array of google.maps.LatLng objects
          var keep = []; // The simplified array of points

          // Check there is something to simplify.
          if (points.length <= 2) {
            return points;
          }

          function distanceToSegment(p, v, w) {

            function distanceSquared(v, w) {
              return Math.pow((v.x - w.x),2) + Math.pow((v.y - w.y),2)
            }
            function distanceToSegmentSquared(p, v, w) {

              var l2 = distanceSquared(v, w);
              if (l2 === 0) return distanceSquared(p, v);

              var t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
              if (t < 0) return distanceSquared(p, v);
              if (t > 1) return distanceSquared(p, w);
              return distanceSquared(p, { x: v.x + t * (w.x - v.x), y: v.y + t * (w.y - v.y) });
            }

            // Lat/Lng to x/y
            function ll2xy(p){
              return {x:p.lat(),y:p.lng()};
            }

            return Math.sqrt(distanceToSegmentSquared(ll2xy(p), ll2xy(v), ll2xy(w)));
          }

          function dp( points, tolerance ) {

            // If the segment is too small, just keep the first point.
            // We push the final point on at the very end.
            if ( points.length <= 2 ) {
              return [points[0]];
            }

            var keep = [],  // An array of points to keep
              v = points[0], // Starting point that defines a segment
              w = points[points.length-1], // Ending point that defines a segment
              maxDistance = 0, // Distance of farthest point
              maxIndex = 0; // Index of said point

            // Loop over every intermediate point to find point greatest distance from segment
            for ( var i = 1, ii = points.length - 2; i <= ii; i++ ) {
              var distance = distanceToSegment(points[i], points[0], points[points.length-1]);
              if( distance > maxDistance ) {
                maxDistance = distance;
                maxIndex = i;
              }
            }

            // check if the max distance is greater than our tollerance allows
            if ( maxDistance >= tolerance ) {

              // Recursivly call dp() on first half of points
              keep = keep.concat( dp( points.slice( 0, maxIndex + 1 ), tolerance ) );

              // Then on second half
              keep = keep.concat( dp( points.slice( maxIndex, points.length ), tolerance ) );

            } else {
              // Discarding intermediate point, keep the first
              keep = [points[0]];
            }
            return keep;
          };

          // Push the final point on
          keep = dp(points, tolerance);
          keep.push(points[points.length-1]);
          return keep;

        };

        var center_x = this.driver.id_driver.id_market.center_x;
        var center_y = this.driver.id_driver.id_market.center_y;

        var map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: center_x ? center_x : 33.637, lng: center_y ? center_y : -84.431},
          zoom: 9,
          minZoom: 7,
          draggableCursor: 'default',
          fullscreenControl: true,
          mapTypeControl: false,
          streetViewControl: false,
        })

        this.map = map;

        var drawingManager = new google.maps.drawing.DrawingManager({
          // drawingMode: google.maps.drawing.OverlayType.MARKER,
          drawingControl: false,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: []
          },
          markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
          polygonOptions: {
            fillColor: '#0074e4',
            fillOpacity: 1,
            strokeWeight: 5,
            clickable: false,
            editable: true,
            zIndex: 1
          }
        })
        drawingManager.setMap(map)
        this.getZone()
      },
    },
    mounted () {
      this.id_driver = this.getUser()['id_user']
      this.getUserInfo()
    },
    created () {
      // document.title = "Verida Support | Driver Dashboard";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table td, .table th {
    vertical-align: middle;
    padding: .85rem;
  }

  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }

  .card-map-body button {
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: bold;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Zone.vue